import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentReviewMedium(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        width={63.5}
        height={78.5}
        x={18.25}
        y={10.87}
        stroke="url(#document_review_medium_svg__a)"
        strokeWidth={8.35}
        rx={13.37}
      />
      <path stroke="#0D2B57" strokeWidth={0.84} d="M32.47 28.84h35.09m-35.09 8.35h35.09" />
      <mask
        id="document_review_medium_svg__b"
        width={37}
        height={37}
        x={59}
        y={56}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M59 56h37v37H59z" />
        <path d="m83.13 77.45 10.78 10.44-2.93 2.97-10.74-10.47c-3.49 2.32-7.27 2.97-11.29 1.87-2.94-.81-5.27-2.52-7.03-4.97-3.55-4.96-2.88-11.93 1.51-16.18 2.22-2.15 5.16-3.44 8.29-3.65a13.28 13.28 0 0 1 8.72 2.52c5.04 3.68 7.19 11.67 2.68 17.47" />
      </mask>
      <path
        fill="#0D2B57"
        d="m83.13 77.45 10.78 10.44-2.93 2.97-10.74-10.47c-3.49 2.32-7.27 2.97-11.29 1.87-2.94-.81-5.27-2.52-7.03-4.97-3.55-4.96-2.88-11.93 1.51-16.18 2.22-2.15 5.16-3.44 8.29-3.65a13.28 13.28 0 0 1 8.72 2.52c5.04 3.68 7.19 11.67 2.68 17.47"
      />
      <path
        stroke="#fff"
        strokeWidth={1.68}
        d="m83.13 77.45 10.78 10.44-2.93 2.97-10.74-10.47c-3.49 2.32-7.27 2.97-11.29 1.87-2.94-.81-5.27-2.52-7.03-4.97-3.55-4.96-2.88-11.93 1.51-16.18 2.22-2.15 5.16-3.44 8.29-3.65a13.28 13.28 0 0 1 8.72 2.52c5.04 3.68 7.19 11.67 2.68 17.47Z"
        mask="url(#document_review_medium_svg__b)"
      />
      <defs>
        <linearGradient
          id="document_review_medium_svg__a"
          x1={50}
          x2={50}
          y1={10.87}
          y2={89.41}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentReviewMedium);
export default ForwardRef;
